import React, {
    Component,
    PureComponent
} from 'react'
import {
    Nav,
    NavLink,
    Link,
} from 'react-router-dom'
import { actionTypes } from '../constants';
import moment from 'moment';
import _ from 'lodash';

import fetch from '../utils/fetch';
import awsconfig from '../awsconfig';

import Icon from '@material-ui/core/Icon';

import EnhancedTable from '../widgets/table-enhanced'
import LinkButton from '../widgets/button-link'
import ChipDetails from '../widgets/chip-details'
import InputClickEditable from '../widgets/input-click-editable'
import DropdownFilterMenu from '../widgets/dropdown-filter-menu';

import ButtonBase from "@material-ui/core/ButtonBase";
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

import DetailView from './reports-detail-overview';
import DocumentsView from './reports-detail-documents';
import ActivityView from './reports-detail-activity-log';



class ReportDetailContainer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            is_loaded: false,
        }
    }

    async componentDidMount() {
        // this.props.dispatch({type: actionTypes.USERS_FETCH_ALL})
        // this.props.dispatch({type: actionTypes.SNACKBAR, snackbar: {severity: 'info', text: 'Lorem ipsum'}})
        this.props.dispatch({type: actionTypes.REPORTS_CLEAR_DETAIL})
        this.props.dispatch({type: actionTypes.REPORTS_FETCH_ONE, id: this.props.match.params.report_id});
    }

    async componentDidUpdate(prevProps, prevState) {
        if(!prevProps.reports.is_loaded && this.props.reports.is_loaded === true && this.props.reports.detail){
        }
    }

    render() {
        console.log(this.props);

        let report = this.props.reports.detail;

        let CurrentView = DetailView;
        switch(this.props.match.params.view){
            case 'activity':
                CurrentView = ActivityView;
                break;
            case 'documents':
                CurrentView = DocumentsView;
                break;
            default:
                CurrentView = DetailView;
                break;
        }

        return (
            <React.Fragment> {/* parent is div.page */}
                <div className="page-nav">
                    <div className="breadcrumb">
                        <Link to={`/app/reports`}>
                            <Icon>arrow_back</Icon>&nbsp;&nbsp;Back to Reports
                        </Link>
                    </div>
                </div>
                <div className="card">
                    <div className="card-content" style={{paddingBottom: 0}}>
                        <h2 className="detail-heading">
                            Incident #{_.get(report, 'accidentNumber', 'LOADING')}
                        </h2>
                        <div className="detail-tabs">
                            <NavLink exact={true} activeClassName='active' to={`/app/reports/${this.props.match.params.report_id}/details`} className="detail-tab">
                                Details
                            </NavLink>
                            <NavLink exact={true} activeClassName='active' to={`/app/reports/${this.props.match.params.report_id}/activity`} className="detail-tab">
                                Activity Log
                            </NavLink>
                            <NavLink exact={true} activeClassName='active' to={`/app/reports/${this.props.match.params.report_id}/documents`} className="detail-tab">
                                Documents
                            </NavLink>
                        </div>
                    </div>
                    <CurrentView {...this.props}/>
                </div>
            </React.Fragment>
        )
    }
}

import { connect } from 'react-redux'
export default connect(
    (state)=>{
        return {
            // accidents: state.accidents,
            reports: state.reports,
        }
    },
    (dispatch)=>{
        return {
            dispatch: dispatch
        }
    },
    null,
    {pure: false}
)(ReportDetailContainer);